import React from 'react';

import styled from 'styled-components';

import {Icon} from 'components/ui-kit/Icon';
import {LABELS} from 'core/constants/labels';
import {breakpoint, colors} from 'theme';

const LogoContainer = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 12px;

    & > img {
        width: 140px;
    }
`;

const LogoIcon = styled(Icon)`
    margin: 0 10px;
    color: ${colors.brandPrimary};
`;

const Text = styled.span`
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    max-width: 120px;

    @media (min-width: ${breakpoint.tablet}) {
        font-size: 8px;
    }
`;

export function Logo() {
    return (
        <LogoContainer>
            <img src={LABELS.icon} alt="Logo" />
        </LogoContainer>
    );
}
